export default __webpack_public_path__ + "static/media/leistungsangebot_line.15c2b1e3.png";